<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="800px"
    title="发起咨询"
    :before-close="handleClose"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      :inline="true"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item
        label="姓名"
        prop="createName"
        maxlength="8"
        class="wh50"
        v-if="isconsult"
        :rules="{
          required: true,
          message: '姓名不能为空',
          trigger: 'blur',
        }"
      >
        <el-input v-model="ruleForm.createName"></el-input>
      </el-form-item>
      <el-form-item
        label="手机号"
        prop="createPhone"
        class="wh50"
        v-if="isconsult"
        :rules="{
          required: true,
          message: '手机号不能为空',
          trigger: 'blur',
        }"
      >
        <el-input v-model="ruleForm.createPhone"></el-input>
      </el-form-item>
      <el-form-item class="wh100" label="提问" prop="queryRemark">
        <el-input
          type="textarea"
          v-model="ruleForm.queryRemark"
          :rows="6"
          maxlength="500"
          placeholder="请输入您想提问的内容"
        ></el-input>
      </el-form-item>
      <el-form-item prop="queryImage">
        <div class="img-list">
          <div
            class="img-list-item"
            v-for="(img, idx) in ruleForm.queryImage"
            :key="img"
          >
            <el-image
              :src="img"
              :preview-src-list="ruleForm.queryImage"
              :initial-index="idx"
            />
            <i class="el-icon-error" @click="removeImg(idx)"></i>
          </div>
          <el-upload
            v-if="ruleForm.queryImage.length < 6"
            ref="upload"
            class="upload-img"
            list-type="picture-card"
            :data="uploadData"
            :action="uploadAction"
            accept=".jpg,.gif,.png,.jpeg,.bmp,.pdf,.GIF,.BMP,.JPG,.JPEG,.PNG"
            name="files"
            multiple
            :on-change="handleFileChange"
            :auto-upload="false"
            :show-file-list="false"
            v-loading="uploading"
          >
            <i class="el-icon-plus"></i>
            <p class="addimg">添加图片</p>
          </el-upload>
        </div>
      </el-form-item>
      <el-form-item class="wh100 ter">
        <el-button @click="resetForm('ruleForm')">取消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">
          确定
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { getFileEncryptParam } from "@/api/request/snkd.foundation";
import { getStorage } from "@/utils/storage";
import { expertConsultation } from "@/api/request/snkd.produce";
import axios from "axios";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
    },
    isconsult: {
      type: Boolean,
      require: true,
    },
    queryId: {
      type: [Number, null],
    },
  },
  data() {
    return {
      uploadAction: "",
      uploadData: {},
      fileObj: {},
      ruleForm: {
        createPhone: "",
        createName: "",
        queryRemark: "",
        queryImage: [],
        farmId: getStorage("FARMINFO").farmId,
      },
      rules: {
        queryRemark: [
          { required: true, message: "请输入您想提问的内容", trigger: "blur" },
        ],
      },
      uploading: false,
      fileLength: 0,
    };
  },
  created() {
    this.getFileEncryptParam();
  },
  mounted() {
    const { companyUserName } = getStorage("COMPANYINFO");
    this.ruleForm.createName = companyUserName;
    this.ruleForm.createPhone = getStorage("PHONE");
  },
  methods: {
    handleClose() {
      this.fileLength = 0;
      this.$emit("closeDialog");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.handleClose();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.isconsult) {
          this.saveConsult();
        } else if (valid && !this.isconsult) {
          this.saveProbe();
        }
      });
    },
    // 保存咨询
    async saveConsult() {
      try {
        const body = {
          ...this.ruleForm,
          queryImage: this.ruleForm.queryImage.toString(),
        };
        await expertConsultation.quizSave(body);
        this.$message.success("提交成功，请耐心等待");
        this.resetForm("ruleForm");
      } catch (error) {
        console.log(error);
      }
    },
    // 保存追问
    async saveProbe() {
      try {
        const { queryImage, createName, queryRemark } = this.ruleForm;
        const body = {
          createName,
          answerImage: queryImage.toString(),
          queryId: this.queryId,
          answerRemark: queryRemark,
        };
        await expertConsultation.probeSave(body);
        this.$message.success("提交成功，请耐心等待");
        this.resetForm("ruleForm");
      } catch (error) {
        console.log(error);
      }
    },
    getFileEncryptParam() {
      getFileEncryptParam().then((res) => {
        this.uploadAction = res.host;
        this.fileObj = res;
      });
    },
    // 上传发生变化钩子
    async handleFileChange(file) {
      if (this.fileLength == 7) return;
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("图片上传大小不超过10MB");
        return false;
      }
      if (this.fileLength >= 6) {
        this.$message({
          message: "图片最多上传6张",
          type: "info",
        });
        this.fileLength += 1;
        return false;
      } else {
        this.fileLength += 1;
        await this.submitFileForm(file);
      }
    },
    // 提交上传文件
    async submitFileForm(file) {
      let formData = new FormData();
      formData.append("key", this.fileObj.dir + "/snkoudai/" + file.name);
      formData.append("OSSAccessKeyId", this.fileObj.accessid);
      formData.append("success_action_status", 200);
      formData.append("policy", this.fileObj.policy);
      formData.append("signature", this.fileObj.signature);
      formData.append("id", file.uid);
      formData.append("name", file.name);
      formData.append("type", file.raw.type);
      formData.append("lastModifiedDate", file.raw.lastModifiedDate);
      formData.append("size", file.size);
      formData.append("file", file.raw);
      await this.uploadFile(formData)
        .then(() => {
          this.ruleForm.queryImage.push(
            `${this.fileObj.host}/${this.fileObj.dir}/snkoudai/${file.name}`
          );
          this.uploading = false;
        })
        .catch(() => {
          this.$message.error("上传失败！");
        });
    },
    removeImg(idx) {
      this.ruleForm.queryImage.splice(idx, 1);
    },
    uploadFile(params) {
      this.uploading = true;
      return axios.post(this.uploadAction, params, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-dialog__header {
  background-color: #64c3a4;
  text-align: center;
  padding: 15px 20px;
}
::v-deep .el-dialog__title {
  color: #fff;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

::v-deep .el-form-item__label {
  text-align: left;
}

::v-deep .el-form-item__content {
  width: 100%;
}
::v-deep .el-form--inline {
  display: flex;
  flex-wrap: wrap;
}
::v-deep .el-form-item {
  margin-bottom: 10px;
  display: block;
  margin-right: 0;
  padding-right: 10px;
  box-sizing: border-box;
}

.wh50 {
  width: 50%;
}

.wh100 {
  width: 100%;
  margin-bottom: 22px;
}

.ter {
  text-align: right;
}

.img-list {
  display: flex;
  flex-wrap: wrap;
  &-item {
    position: relative;
    line-height: 1;
    ::v-deep .el-image {
      width: 80px;
      height: 80px;
      border-radius: 4px;
      margin-right: 10px;
    }
    .el-icon-error {
      position: absolute;
      right: 2px;
      top: -8px;
      font-size: 18px;
      background-color: #fff;
      border-radius: 50%;
      color: #dadada;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
}
.upload-img {
  position: relative;
}
.addimg {
  position: absolute;
  top: -11px;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  color: #666;
}

::v-deep .el-upload {
  width: 80px;
  height: 80px;
  .el-icon-plus {
    font-size: 16px;
    position: absolute;
    top: 32px;
    left: 32px;
  }
}
</style>
